module.exports = __webpack_public_path__ + "img/product_92.b7cbb5c.webp";